
import {
  defineStore
} from 'pinia'

export const useVariantCollectionStore = defineStore('VariantCollectionStore', {
  state: () => {
    return {
      slideoutOpen: false
    }
  },

  actions: {
    openSlideout () {
      this.slideoutOpen = true
      document.body.classList.add('overflow-hidden')
    },
    closeSlideout (event = null) {
      if (!event || event.target.hasAttribute('data-close')) {
        this.slideoutOpen = false
        document.body.classList.remove('overflow-hidden')
      }
    }
  },

  getters: {
  },
})
